import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["for"]
const _hoisted_2 = ["name", "min", "max", "step", "value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AutomateRangeEffectControl = _resolveComponent("AutomateRangeEffectControl")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("button", {
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleRemoveEffect && _ctx.handleRemoveEffect(...args)))
    }, "Remove"),
    _createElementVNode("label", {
      for: `${_ctx.effect.name}-ctrl`
    }, _toDisplayString(_ctx.effect.name), 9, _hoisted_1),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.effect.params, (param) => {
      return (_openBlock(), _createElementBlock("div", {
        key: param.name
      }, [
        _createElementVNode("input", {
          type: "range",
          name: param.name,
          ref_for: true,
          ref: `${param.name}-ctrl`,
          min: param.min,
          max: param.max,
          step: param.step,
          value: param.value,
          onInput: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleValueChange && _ctx.handleValueChange(...args)))
        }, null, 40, _hoisted_2),
        (!_ctx.showAutomationControls)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showAutomationControls = true))
            }, " Automate "))
          : _createCommentVNode("", true),
        (_ctx.showAutomationControls)
          ? (_openBlock(), _createBlock(_component_AutomateRangeEffectControl, {
              key: 1,
              inputAttributes: _ctx.getInputAttributes(param.name),
              updateRangeInput: _ctx.createRangeInputUpdater(param.name),
              onAutomationRemoved: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showAutomationControls = false))
            }, null, 8, ["inputAttributes", "updateRangeInput"]))
          : _createCommentVNode("", true)
      ]))
    }), 128))
  ], 64))
}